import { render, staticRenderFns } from "./pulsepointlife.vue?vue&type=template&id=6d4f5afc&scoped=true&v-once=true"
import script from "./pulsepointlife.vue?vue&type=script&lang=js"
export * from "./pulsepointlife.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d4f5afc",
  null
  
)

export default component.exports